import SpriteSymbol from "../../../../../../../sfra-webpack-builder/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../sfra-webpack-builder/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "warning",
  "use": "warning-usage",
  "viewBox": "0 0 20 17",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 17\" id=\"warning\"><path fill=\"#EFC100\" fill-rule=\"evenodd\" d=\"M10.583 1.104a2 2 0 0 1 .65.651l7.532 12.194A2 2 0 0 1 17.063 17H2a2 2 0 0 1-1.702-3.051L7.83 1.755a2 2 0 0 1 2.753-.65zM9.464 13a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5zm0-7a.75.75 0 0 0-.75.75v4.5a.75.75 0 1 0 1.5 0v-4.5a.75.75 0 0 0-.75-.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol